import Helper from './Helper';

class CV {
  constructor(config = {}) {
    const {
      cv,
    } = config;
    this.cv = Array.prototype.slice.call(document.querySelectorAll(cv));
    this.currentEl = null;
    if(this.cv && this.cv.length !== 0){
      this.notebox = document.querySelector('.nhsnote-box');
      this.noteboxInner = document.querySelector('.js-nhsnote-box-inner');
      this.noteboxContent = document.querySelector('.js-nhsnote-box-content');
      this.body = document.querySelector('body');
      this.bindEvents();
    }
  }

  bindEvents() {
    this.cv.forEach(el => {
      el.addEventListener('click', (e) => {
        //Helper.slideToggle(el.nextElementSibling);
        //Helper.toggleClass(el, 'active');
        const item = Helper.getParentNodeWithClass(el, 'cv-item');

        const content = item.querySelector('.cv-item__content');
        const img = item.querySelector('img.cv-image__img');
        const title = item.querySelector('.cv-item__name');

        this.openNoteBox(this.buildTemplate(title, img, content));
      });
    });
  }

  openNoteBox(html){
    if(!this.body.classList.contains('notes-open')){
      this.body.classList.add('notes-open');
    }
    if(!this.notebox.classList.contains('nhsnote-box--loaded')){
      this.notebox.classList.add('nhsnote-box--loaded');
    }
    this.notebox.style.display = 'block';
    this.noteboxInner.style.display = 'block';
    this.noteboxContent.innerHTML = html;
  }

  buildTemplate(title, img, content){
    //console.log(img);
    let html = `
      <h2 class="ns-title-h2">${title.innerText}</h2>
      <div class="cv-popup">`;

    // Only add image section if image exists
    if (img) {
      const imgUrl = img.dataset.src || img.src;
      html += `
        <div class="cv-popup__left">
          <img src="${imgUrl}" alt="${title.innerText}" />
        </div>`;
    }

    html += `
        <div class="cv-popup__right">
          ${content.innerHTML}
        </div>
      </div>
      `;

    return html;
  }

}

export default CV;
